"use client";

import { FC, useCallback } from "react";
import { useRouter } from "next/navigation";
import BFLTabs from "@repo/shared-ui/BFLTabs";
import { handleRedirection } from "../../utils/helper";
import {
  parseUpcomingIpoNavTabs,
  UpcomingIpoNavTabsContent,
} from "./parseUpcomingIpoNavTabs";

const UPCOMING_IPO_TAB_GUTTER =
  "pl-[16px] pr-[16px] pt-[16px] md:pl-[24px] md:pt-[12px] lg:pl-[141px] lg:pr-[16px]";

const UPCOMING_IPO_TAB_DIVIDER =
  "h-[1px] border-none bg-[#cccccc] pl-[16px] lg:ml-[140px] lg:max-w-[900px]";

interface UpcomingIpoTabsProps {
  content?: UpcomingIpoNavTabsContent;
}

const UpcomingIpoTabs: FC<UpcomingIpoTabsProps> = ({ content }) => {
  const { activeTab, tabs } = parseUpcomingIpoNavTabs(content);
  const router = useRouter();

  const handleTabChange = useCallback(
    (newTabValue: string) => {
      if (newTabValue === activeTab) return;

      const selectedTab = tabs.find((tab) => tab.value === newTabValue);
      if (!selectedTab?.redirectLink) return;

      handleRedirection(selectedTab.redirectLink, router);
    },
    [activeTab, router, tabs],
  );

  return (
    <>
      <div className={UPCOMING_IPO_TAB_GUTTER}>
        <BFLTabs
          className="border-none pb-0 pt-[0px] md:pt-[12px] text-[12px] lg:text-[16px]"
          tabClassName="relative cursor-pointer whitespace-nowrap p-0 mr-[12px] md:mr-[36px]"
          gapClassName="pb-[8px] md:pb-[12px]"
          indicatorClassName="bottom-[-10px] md:bottom-[-13px]"
          color="text-[#002953]"
          selectedTab={activeTab}
          onTabChange={handleTabChange}
          tabs={tabs.map(({ label, value }) => ({ label, value }))}
        />
      </div>
      <hr className={UPCOMING_IPO_TAB_DIVIDER} />
    </>
  );
};

export default UpcomingIpoTabs;
